"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserContext = exports.UserContext = void 0;
const makeContextAndHook_1 = require("../utils/makeContextAndHook");
/**
 * @internal
 */
_a = (0, makeContextAndHook_1.makeContextAndHook)('UserContext'), exports.UserContext = _a[0], exports.useUserContext = _a[1];
//# sourceMappingURL=UserContext.js.map